import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4 whitespace-nowrap">
            漫画分类
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画主题索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">按题材分类浏览，快速找到你感兴趣的漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 rounded-lg bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-500 text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-0.5 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 whitespace-nowrap">{item.desc}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}